<template>
    <div >
        <div @click="toggleShowOrHide">
            <span class="float-right " @click.stop="deleteQuery">
                <font-awesome-icon icon="trash-alt"/>
            </span>
            <div>
              <b>{{query.name}}</b>
              <span v-if="query.status == 'unread'" class="new-span font-12">
                NEU
              </span>
            </div>
            <h6>{{query.obj_name}} ({{query.object_id}})</h6>
            <h6>{{query.zeit}} Uhr {{query.datum}}</h6>
        </div>
        <div v-if="show" class="container">
                <div class="mt-4">
                    <strong>Anfragedetails</strong>
                </div>
                <table class="table table-sm table-borderless">
                    <tr class="bottom-line">
                        <th>Datum</th>
                        <td>{{query.datum}}</td>
                    </tr>
                    <tr v-if="query.company != ''" class="bottom-line">
                        <th>Firma</th>
                        <td>{{query.company}}</td>
                    </tr>
                    <tr class="bottom-line">
                        <th>Name</th>
                        <td>{{query.name}}</td>
                    </tr>
                    <tr class="bottom-line">
                        <th>E-Mail</th>
                        <td><a :href="'mailto:' + query.email" class="text-dark">{{query.email}}</a></td>
                    </tr>
                    <tr class="bottom-line">
                        <th>Telefon</th>
                        <td><a :href="'tel:' + query.phone" class="text-dark">{{query.phone}}</a></td>
                    </tr>
                    <tr class="bottom-line">
                        <th>PLZ / Ort</th>
                        <td>{{query.plzort}}</td>
                    </tr>
                    <tr>
                        <th>Zeitraum</th>
                        <td v-if="query.date_from == '01.01.1970' || query.date_to == '01.01.1970'">
                          Keine Angabe
                        </td>
                        <td v-else>
                          {{query.date_from }} bis {{query.date_to}}
                        </td>
                    </tr>
                </table>
                <div>
                    <strong>Anfrage</strong>
                    <p>{{query.text}} </p>
                </div>
                <button class="btn btn-success btn-sm" @click="showCommentForm">
                    {{$t('intern_objekte_anfragen_details.neuer_kommentar')}}
                </button>
                <div class="form-group mt-4 d-none" ref="form">
                    <textarea
                        class="form-control"
                        v-model="comment"
                        :class="{ 'is-invalid': $v.comment.$error }"
                        placeholder="Schreiben Sie Ihren Kommentar"
                    ></textarea>
                    <div class="invalid-feedback" v-if="!$v.comment.required">Bitte Kommentar eingeben</div>
                    <button class="btn btn-success mt-2" @click="newComment">
                        Speichern
                    </button>
                </div>
                <div class="mt-3" v-if="comments.length > 0">
                    <strong>Kommentare</strong>
                    <query-comment-component
                        v-for="comment in comments"
                        :key="comment.id"
                        :comment="comment"
                        @delete="comments = comments.filter(c => c.id != comment.id)"
                    />
                </div>
            </div>
    </div>
</template>

<script>
    import EventBus from '../../EventBus';
    import {required} from "vuelidate/lib/validators";
    import QueryCommentComponent from "@/components/queries/QueryComment";

    export default {
        props: ['query'],
        data(){
          return {
            show : false,
            comment: '',
            comments: []
          }
        },
        components: {
            QueryCommentComponent
        },
        methods: {
            showCommentForm() {
                let form = this.$refs.form;

                if(form.classList.contains('d-none')){
                    form.classList.remove('d-none');
                }else {
                    form.classList.add('d-none');
                }
            },
            toggleShowOrHide(){
              this.show = !this.show;
              let query = this.query;
              if(query && typeof query === 'object') {
                  this.fetchComments();

                  if(query && typeof query === 'object' && query.status == 'unread') {
                      this.$store.state.loading = true;
                      this.$http.put('queryApi/readQuery?id=' + this.query.id).then(response => {
                          if(response.data == 'success'){
                              this.$store.dispatch('NOTIFICATIONS_COUNT');
                          }
                      }).catch( error => {
                          console.log(error);
                      }).then(() => {
                          this.$store.state.loading = false;
                      });
                  }
              }
              this.changeStatusToRead();
            },
            fetchComments() {
                this.$store.state.loading = true;
                this.$http.get('/queryApi/getQueryComment/?query_id=' + this.query.id).then( response => {
                    this.comments = JSON.parse(response.data);
                }).catch( error => {
                    console.log(error);
                }).then(() => {
                    this.$store.state.loading = false;
                })
            },
            newComment() {
                this.$v.$touch();
                if(!this.$v.$invalid){
                    let data = {
                        id: this.query.id,
                        comment: this.comment
                    };

                    this.$store.state.loading = true;
                    this.$http.post('/queryApi/createQueryComment', data).then( response => {
                        this.comment = '';
                        this.$nextTick(() => { this.$v.$reset() })
                        this.$bvToast.toast(response.data, {
                            variant: 'success'
                        });
                    }).catch( error => {
                        this.$bvToast.toast(error.response.data.data, {
                            title: 'Fehlermeldung',
                            variant: 'danger'
                        });
                    }).then(() => {
                        this.$store.state.loading = false;
                        this.showCommentForm();
                        this.fetchComments();
                    });
                }
            },
            /*readQuery() {
                EventBus.$emit('READ_QUERY', this.query);
                this.changeStatusToRead();
            },*/
            deleteQuery() {
                this.$bvModal.msgBoxConfirm('Möchten Sie diese Anfrage wirklich löschen?', {
                    okVariant: 'danger',
                    okTitle: 'Löschen',
                    cancelTitle: 'Abbrechen'
                }).then( val => {
                    if(val){
                        this.$store.state.laoding = true;
                        this.$http.delete('/queryApi/deleteQuery?id=' + this.query.id).then( response => {
                            EventBus.$emit('DISPATCH_QUERIES');
                        }).catch( error => {console.log(error);}).catch(() => {
                            this.$store.state.laoding = false;
                        }).then(() => {
                            this.$store.state.loading = false;
                            setTimeout(() => {
                                this.$bvToast.toast('Die Anfrage ist erfolgreich gelöscht', {
                                  title: 'Benachrichtigung',
                                  variant: 'success'
                                });
                            },500);
                        });
                    }
                });
            },
            changeStatusToRead() {
                this.query.status = 'read';
            }
        },
        validations: {
            comment: { required }
        }
    }
</script>

<style scoped>
.new-span{
  background-color: #5FA963;
  color: white;
  padding: 2px 5px 2px 0px;
  margin: 10px;
  border-radius: 4px;
}
.bottom-line{
  border-bottom: 1px solid gray;
}
.btn-success{
  color: #fff;
  background-color: #5FA963 !important;
  border-color: #5FA963 !important;
}
</style>
